import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, Form, Input, App, Flex } from 'antd';
import { createEvent } from 'api/events';
import { fetchConfig } from 'api/config';
import { useI18n } from 'components/I18nProvider';
import { useEffect, useState } from 'react';
import { EVENT_ID_PATTERN } from 'lib/eventIdValidation';
const { TextArea } = Input;
const NewEventDialog = ({ open, onNewEvent, onClose }) => {
    const { intl } = useI18n();
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [eventOrigin, setEventOrigin] = useState('');
    useEffect(() => {
        if (!open) {
            form.resetFields();
            return;
        }
        const loadOrigin = async () => {
            const config = await fetchConfig();
            setEventOrigin(config.publicEventOrigin);
        };
        void loadOrigin();
    }, [open, form]);
    const handleOk = () => {
        form.submit();
    };
    const handleFinish = async (values) => {
        setLoading(true);
        try {
            const customId = values.customId?.trim();
            const result = await createEvent(values.title, values.description ?? '', customId || undefined);
            if (result === 'already-exists') {
                form.setFields([
                    {
                        name: 'customId',
                        errors: [intl.formatMessage({ id: 'eventIdExists' })],
                    },
                ]);
                return;
            }
            if (result === 'invalid-id-format') {
                void message.error(intl.formatMessage({ id: 'invalidEventCode' }));
                return;
            }
            onNewEvent(result);
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx(Modal, { title: intl.formatMessage({ id: 'newEvent' }), open: open, onOk: handleOk, onCancel: onClose, confirmLoading: loading, okButtonProps: { disabled: loading, 'test-id': 'admin-new-event-dialog-ok' }, cancelButtonProps: { 'test-id': 'admin-new-event-dialog-cancel' }, getContainer: false, children: _jsxs(Form, { form: form, initialValues: { title: '', customId: '' }, onFinish: handleFinish, disabled: loading, children: [_jsx(Form.Item, { label: intl.formatMessage({ id: 'title' }), name: "title", rules: [{ required: true, message: 'Please input title!' }], children: _jsx(Input, { autoFocus: true, "test-id": "admin-new-event-title-input" }) }), _jsx(Form.Item, { label: intl.formatMessage({ id: 'description' }), name: "description", children: _jsx(TextArea, { rows: 3, "test-id": "admin-new-event-description-textarea" }) }), _jsx(Form.Item, { label: intl.formatMessage({ id: 'eventUrlOptional' }), extra: intl.formatMessage({ id: 'eventUrlOptionalHint' }), children: _jsxs(Flex, { align: "baseline", gap: "small", wrap: "wrap", style: { width: '100%' }, children: [_jsx("span", { style: { flexShrink: 0, whiteSpace: 'nowrap' }, children: eventOrigin ? `${eventOrigin}#` : intl.formatMessage({ id: 'loading' }) }), _jsx("div", { style: {
                                    flex: '1 1 80px',
                                    minWidth: 80,
                                    maxWidth: '100%',
                                }, children: _jsx(Form.Item, { name: "customId", noStyle: true, rules: [
                                        {
                                            validator: async (_, value) => {
                                                const v = value?.trim() ?? '';
                                                if (v === '') {
                                                    return;
                                                }
                                                if (!EVENT_ID_PATTERN.test(v)) {
                                                    throw new Error(intl.formatMessage({ id: 'invalidEventCode' }));
                                                }
                                            },
                                        },
                                    ], children: _jsx(Input, { style: { width: '100%' }, placeholder: intl.formatMessage({ id: 'eventUrlOptionalPlaceholder' }), "test-id": "admin-new-event-custom-id-input" }) }) })] }) })] }) }));
};
export default NewEventDialog;
